import { useState } from "react";
import { Snackbar, Alert, Box, Typography } from "@mui/material";
import SettingControl from "./SettingControl";
import { useSettingGroups } from "../../hooks/useSettings";
import { GROUP_MAP } from "../../settings/groups";
import SettingRow from "./SettingRow";

interface Props {
  group: string;
  highlightedRowId: string | null;
}

export default function SettingsPanel({ group, highlightedRowId }: Props) {
  const groups = useSettingGroups();
  const [error, setError] = useState<string | null>(null);

  const entries = groups.find((g) => g.group === group)?.entries ?? [];
  const meta = GROUP_MAP[group];

  return (
    <Box>
      <Typography fontSize={15} fontWeight={600} sx={{ mb: 1.5 }}>
        {meta?.title ?? group}
      </Typography>

      <Box sx={{ border: "0.5px solid", borderColor: "grey.200", borderRadius: "12px", overflow: "hidden" }}>
        {entries.length === 0 ? (
          <Typography sx={{ p: 2, fontSize: 13, color: "text.secondary" }}>표시할 설정이 없습니다.</Typography>
        ) : (
          entries.map((entry) => (
            <SettingRow
              key={entry.key}
              id={entry.key}
              label={entry.def.title}
              description={entry.def.description}
              highlighted={highlightedRowId === entry.key}
            >
              <SettingControl entry={entry} onError={setError} />
            </SettingRow>
          ))
        )}
      </Box>

      <Snackbar open={!!error} autoHideDuration={4000} onClose={() => setError(null)}>
        <Alert severity="error" onClose={() => setError(null)}>
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
}
